import { render, staticRenderFns } from "./informationMessage.vue?vue&type=template&id=e634002a&scoped=true"
import script from "./informationMessage.vue?vue&type=script&lang=js"
export * from "./informationMessage.vue?vue&type=script&lang=js"
import style0 from "./informationMessage.vue?vue&type=style&index=0&id=e634002a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e634002a",
  null
  
)

export default component.exports